"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _botframeworkWebchatApi = require("botframework-webchat-api");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useLocalizer = _botframeworkWebchatApi.hooks.useLocalizer;

var VideoAttachment = function VideoAttachment() {
  var localize = useLocalizer();
  var label = localize('ATTACHMENT_VIDEO');
  return /*#__PURE__*/_react.default.createElement("article", null, label);
};

var _default = VideoAttachment;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VMb2NhbGl6ZXIiLCJob29rcyIsIlZpZGVvQXR0YWNobWVudCIsImxvY2FsaXplIiwibGFiZWwiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9NaWRkbGV3YXJlL0F0dGFjaG1lbnRGb3JTY3JlZW5SZWFkZXIvVmlkZW9BdHRhY2htZW50LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGhvb2tzIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IHsgdXNlTG9jYWxpemVyIH0gPSBob29rcztcblxuY29uc3QgVmlkZW9BdHRhY2htZW50ID0gKCkgPT4ge1xuICBjb25zdCBsb2NhbGl6ZSA9IHVzZUxvY2FsaXplcigpO1xuXG4gIGNvbnN0IGxhYmVsID0gbG9jYWxpemUoJ0FUVEFDSE1FTlRfVklERU8nKTtcblxuICByZXR1cm4gPGFydGljbGU+e2xhYmVsfTwvYXJ0aWNsZT47XG59O1xuXG5leHBvcnQgZGVmYXVsdCBWaWRlb0F0dGFjaG1lbnQ7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7OztBQUVBLElBQVFBLFlBQVIsR0FBeUJDLDZCQUF6QixDQUFRRCxZQUFSOztBQUVBLElBQU1FLGVBQWUsR0FBRyxTQUFsQkEsZUFBa0IsR0FBTTtFQUM1QixJQUFNQyxRQUFRLEdBQUdILFlBQVksRUFBN0I7RUFFQSxJQUFNSSxLQUFLLEdBQUdELFFBQVEsQ0FBQyxrQkFBRCxDQUF0QjtFQUVBLG9CQUFPLDhDQUFVQyxLQUFWLENBQVA7QUFDRCxDQU5EOztlQVFlRixlIn0=